'use strict';
module.exports = {

    openSingleFilterTab: function() {
        $(document).on('click', '.collapsible-title', function() {
            $(this).each(function() {
                var content = this.nextElementSibling;
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                    content.style.visibility = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    content.style.visibility = 'visible';
                    let $values = $(content).find('input');
                    if ($values.length > 0) {
                        $values[0].focus();
                    }
                }
            });
        });
    },

    changeArrowUpDown: function() {
        $(document).on('click', '.collapsible-title', function() {
            var categoryId = $(this).data('pid');
            if ($('.down-filter-collapse-' + categoryId).hasClass('d-none')) {
                $('.down-filter-collapse-' + categoryId).removeClass('d-none');
                $('.up-filter-collapse-' + categoryId).addClass('d-none');
            } else {
                $('.down-filter-collapse-' + categoryId).addClass('d-none');
                $('.up-filter-collapse-' + categoryId).removeClass('d-none');
            }
        });
    }

};
